<template>
    <div class="rounded-lg border border-gray-300 bg-white overflow-hidden">
        <!-- title -->
        <div class="px-4 py-2 bg-lightestblue-100 flex items-center">
            <font-awesome-icon class="text-lg text-bluegray-600 mr-2" :icon="row.icon" />
            <span class="font-medium">{{ row.rowTitle }}</span>
        </div>

        <div class="p-4 space-y-4 text-sm text-gray-700">
            <!-- pros -->
            <section>
                <div class="flex items-center gap-2 mb-1 text-lg">
                    <font-awesome-icon class="text-lg text-green-200" icon="check" />
                    <h3 class="font-medium">Fordeler</h3>
                </div>

                <ResizableTextArea :name="id" class="h-full nomargin border-none" :placeholder="prosValue"
                    :readOnly="readOnly" v-on:change="save" v-model="prosValue" :inTable="true" />
            </section>

            <!-- cons -->
            <section>
                <div class="flex items-center gap-2 mb-1 text-lg">
                    <font-awesome-icon class="text-lg text-red-200" icon="times" />
                    <h3 class="font-medium">Ulemper</h3>
                </div>

                <ResizableTextArea :name="id" class="h-full nomargin border-none" :placeholder="consValue"
                    :readOnly="readOnly" v-on:change="save" v-model="consValue" :inTable="true" />
            </section>
        </div>
    </div>
</template>

<script>
import ResizableTextArea from '@/views/components/textarea/ResizableTextArea.vue';

export default {
    props: { row: Object, readOnly: Boolean, pageId: String },
    components: {
        ResizableTextArea,
    },
    data() {
        return {
            prosValue: this.row?.pros || '',
            consValue: this.row?.cons || '',
            isSaving: false,
        };
    },
    computed: {
        prosList() {
            return (this.row?.pros || '').split('\n').filter(Boolean);
        },
        consList() {
            return (this.row?.cons || '').split('\n').filter(Boolean);
        },
    },
    methods: {
        async save() {
            // same backend as your row component
            const body = {
                id: this.row.id,
                prosValue: this.prosValue,
                consValue: this.consValue,
                pageId: this.pageId,
            };
            this.isSaving = true;
            await fetch(`${window.location.origin}/api/schema/SaveProsConsRow`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            }).finally(() => (this.isSaving = false));
            this.$emit('onSave');
            this.$emit('getSchema');
            this.$toast?.open?.({ message: 'Lagret', type: 'success', dismissible: true });
        },
    },
    emits: ['onSave', 'getSchema'],
};
</script>
